import React, { useContext } from 'react';
import '../App.css';
import SkillComponent from '../components/SkillComponent.js';
import AppsComponent from '../components/AppsComponent.js';
import CredentialComponent from '../components/CredentialComponent.js';
import LabComponent from '../components/LabComponent.js';
import { labs } from '../data/labs.js';
import ToolGroupComponent from '../components/ToolGroupComponent.js';
import EmailComponent from '../components/EmailComponent.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faSun, faMoon, faShieldHalved, faMagnifyingGlassChart, faNetworkWired,
         faTriangleExclamation, faDesktop, faTerminal, faGraduationCap,
         faCertificate, faLocationDot, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from '../ThemeContext.js';
import psImg from '../img/ps.jpg';
// import imageFetch from '../img/imagefetch.jpg';
// import expensesList from '../img/expenseslist.jpg';
// import taskList from '../img/tasklist.jpg';
// import whattacook from '../img/whattacook.jpg';
import diazClothes from '../img/diazclothes.jpg';
import ayPanda from '../img/aypanda.jpg';
import isi from '../img/isi.jpg';
import inti from '../img/inti.jpg';
import { Outlet, Link, useLocation } from "react-router-dom";


function Home () {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let location = useLocation();
    return(
        <>
            <div className="block header-contact" id="top">
                <a className="header-monogram" href="#top" title="Arturo Nuñez" aria-label="Arturo Nuñez, back to top">AN</a>
                <div>
                <a title='Github' rel="noreferrer" target='_blank' href='https://github.com/thearturord?tab=repositories'><FontAwesomeIcon icon={faSquareGithub} size='2xl' className="social-icon" /></a>
                <a title='Linkedin' rel="noreferrer" target='_blank' href='https://www.linkedin.com/in/thearturord'><FontAwesomeIcon icon={faLinkedin} size='2xl' className="social-icon" /></a>
                <a title='TryHackMe' rel="noreferrer" target='_blank' href='https://tryhackme.com/p/thearturord123'><FontAwesomeIcon icon={faUserSecret} size='2xl' className="social-icon" /></a>
                <button
                    className="theme-toggle"
                    onClick={toggleTheme}
                    title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                    aria-label="Toggle theme"
                >
                    <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} size='lg' />
                </button>
                </div>
            </div>
            <main>
                <div className="block about">
                    <div className="about-img-wrap">
                        <img className="img-fluid about-img" src={psImg} alt="Arturo Nuñez"></img>
                    </div>
                    <div className="about-title">
                        <span className="about-eyebrow">Arturo Nuñez</span>
                        <h2>
                            Cybersecurity Analyst — Blue Team &amp; Threat Detection
                        </h2>
                        <p className="about-location">
                            <FontAwesomeIcon icon={faLocationDot} /> Berlin, Germany
                        </p>
                        <p className="about-title-p">
                            I work on the defensive side of security: monitoring, log analysis, threat detection
                            and incident response. I completed the Cybersecurity Bootcamp at Ironhack Berlin and
                            hold the TryHackMe SOC Level 1 certification.
                        </p>
                        <p className="about-title-p">
                            Before moving into security I spent years building and shipping web applications.
                            That background means I read application code, network traffic and logs as one
                            picture instead of three separate ones — which is exactly what triaging an alert asks for.
                        </p>
                        <div className="about-chips">
                            <span className="about-chip">SOC Operations</span>
                            <span className="about-chip">SIEM &amp; Log Analysis</span>
                            <span className="about-chip">Incident Response</span>
                            <span className="about-chip">MITRE ATT&amp;CK</span>
                            <span className="about-chip">Cloud Security</span>
                        </div>
                    </div>
                    <div className="about-panel">
                        <span className="about-panel-status">
                            <span className="status-dot"></span> Open to work
                        </span>
                        <div className="about-panel-facts">
                            <div className="about-fact">
                                <span className="about-fact-label">Focus</span>
                                <span className="about-fact-value">SOC · Blue Team</span>
                            </div>
                            <div className="about-fact">
                                <span className="about-fact-label">Based in</span>
                                <span className="about-fact-value">Berlin, Germany</span>
                            </div>
                            <div className="about-fact">
                                <span className="about-fact-label">Work setup</span>
                                <span className="about-fact-value">On-site · Hybrid</span>
                            </div>
                        </div>
                        <a className="about-panel-cta" href="#contact">
                            Get in touch
                        </a>
                    </div>
                </div>

                <div className="block skill-set">
                    <div className="skill-set-title">
                        <h2>Core Competencies</h2>
                    </div>
                    <div className='skill-set-wrap'>
                        <div className='row skill-set-row'>
                        <SkillComponent skillName="Security Operations" skillDescription="Day-to-day SOC work: alert triage, monitoring of security events, and escalation of confirmed incidents through a defined process." icon={faShieldHalved} skillColor="#3DDC97" />
                        <SkillComponent skillName="SIEM & Log Analysis" skillDescription="Collecting, correlating and querying logs from endpoints, network devices and applications to separate real threats from noise." icon={faMagnifyingGlassChart} skillColor="#4FB3F6" />
                        <SkillComponent skillName="Threat Detection" skillDescription="Mapping adversary behaviour to MITRE ATT&CK techniques and turning it into detection logic instead of chasing isolated indicators." icon={faTriangleExclamation} skillColor="#F5A524" />
                        </div>
                        <div className='row skill-set-row'>
                        <SkillComponent skillName="Network Analysis" skillDescription="Reading traffic at packet level with Wireshark, mapping exposure with Nmap, and knowing protocols well enough to spot what does not belong." icon={faNetworkWired} skillColor="#8B7CF6" />
                        <SkillComponent skillName="Endpoint & Access Control" skillDescription="Endpoint hardening, authentication and authorisation models, and least-privilege access as a first line of defence." icon={faDesktop} skillColor="#EC6A9C" />
                        <SkillComponent skillName="Scripting & Automation" skillDescription="Bash, PowerShell and JavaScript used to automate log parsing, repetitive investigation steps and routine security checks." icon={faTerminal} skillColor="#56C7D6" />
                        </div>
                    </div>
                </div>

                <div className="block tools">
                    <div className="tools-header">
                        <h2>Tools &amp; Frameworks</h2>
                    </div>
                    <div className="tools-wrap">
                        <ToolGroupComponent groupName="Detection & Monitoring"
                            tools={["SIEM", "Log Analysis", "Endpoint Security", "Security Monitoring"]} />
                        <ToolGroupComponent groupName="Network & Assessment"
                            tools={["Wireshark", "Nmap", "Hydra", "Vulnerability Assessment"]} />
                        <ToolGroupComponent groupName="Frameworks"
                            tools={["MITRE ATT&CK", "OWASP Top 10", "Access Control", "Incident Response"]} />
                        <ToolGroupComponent groupName="Scripting"
                            tools={["Bash", "PowerShell", "JavaScript", "Security Automation"]} />
                    </div>
                </div>

                <div className="block credentials">
                    <div className="credentials-header">
                        <h2>Certifications &amp; Training</h2>
                    </div>
                    <div className="credentials-wrap">
                        <CredentialComponent
                            icon={faCertificate}
                            iconColor="#3DDC97"
                            title="SOC Level 1 Certificate"
                            issuer="TryHackMe"
                            meta="Issued Sep 2026 · Valid through Sep 2029"
                            description="Hands-on certification covering the day-to-day responsibilities of a Tier 1 SOC analyst."
                            highlights={[
                                "Alert triage and investigation workflow",
                                "SIEM queries and log correlation",
                                "Network and endpoint traffic analysis",
                                "Incident response and documentation"
                            ]}
                            credentialId="THM-KW12HXLE84"
                            hrefCredential="https://tryhackme.com/p/thearturord123?tab=certificates" />

                        <CredentialComponent
                            icon={faGraduationCap}
                            iconColor="#4FB3F6"
                            title="Cybersecurity Bootcamp"
                            issuer="Ironhack Berlin"
                            meta="9 weeks · Jul 2026 – Sep 2026"
                            description="Intensive, lab-driven program built around the Blue Team and security operations track."
                            highlights={[
                                "Networking and security operations fundamentals",
                                "SIEM, log analysis and endpoint security",
                                "Access control and vulnerability assessment",
                                "OWASP, MITRE ATT&CK, Nmap and Hydra"
                            ]}
                            credentialId="aa7ce7c4-64d4-4073-b793-ae0560b3c864"
                            hrefCredential="https://www.credential.net/aa7ce7c4-64d4-4073-b793-ae0560b3c864" />
                    </div>
                </div>

                <div className="block apps" id="labs">
                    <div className="apps-header">
                        <h2>
                            Security Labs &amp; Write-ups
                        </h2>
                    </div>
                    <p className="section-note">
                        Documented investigations from SOC labs and detection exercises, written as incident-style
                        reports. Technique-level only: no flags or room answers.
                    </p>
                    <div className="credentials-wrap">
                        <LabComponent
                            icon={faMagnifyingGlassChart}
                            iconColor="#4FB3F6"
                            title={labs[0].title}
                            platform={labs[0].platform}
                            tags={labs[0].tags}
                            meta={labs[0].meta}
                            description={labs[0].card}
                            highlights={labs[0].highlights}
                            slug={labs[0].slug}
                            pdf={labs[0].pdf} />
                        <LabComponent
                            icon={faTerminal}
                            iconColor="#F5A524"
                            title={labs[1].title}
                            platform={labs[1].platform}
                            tags={labs[1].tags}
                            meta={labs[1].meta}
                            description={labs[1].card}
                            highlights={labs[1].highlights}
                            slug={labs[1].slug}
                            pdf={labs[1].pdf} />
                    </div>
                </div>

                <div className="block apps">
                    <div className="apps-header">
                        <h2>
                            Development Background
                        </h2>
                    </div>
                    <p className="section-note">
                        Client websites and applications built before moving into security. Knowing how these
                        are put together is what makes it possible to reason about how they get attacked.
                    </p>
                    <div className="row apps-wrap">
                        <AppsComponent img={diazClothes} appName="Diaz Clothes" hrefApp="https://diazclothes.com/"
                        hrefCode={undefined}
                        appSkills = {{
                        skillName: ["Wordpress"],
                        skillPorcentage: ["100%"],
                        SkillColor: ["progress-bar progress-bar-striped bg-info"]
                        }} />
                        <AppsComponent img={ayPanda} appName="Ay Panda" hrefApp="https://aypanda.com/"
                        hrefCode={undefined}
                        appSkills = {{
                        skillName: ["Wordpress"],
                        skillPorcentage: ["100%"],
                        SkillColor: ["progress-bar progress-bar-striped bg-info"]
                        }} />
                        <AppsComponent img={isi} appName="ISI-Poutine" hrefApp={"https://isipoutine.de/"}
                        hrefCode={undefined}
                        appSkills = {{
                        skillName: ["Wordpress"],
                        skillPorcentage: ["100%"],
                        SkillColor: ["progress-bar progress-bar-striped bg-info"]
                        }} />
                        <AppsComponent img={inti} appName="Inti Elektrotechnik" hrefApp={"https://intielektrotechnik.de/"}
                        hrefCode={undefined}
                        appSkills = {{
                        skillName: ["Wordpress"],
                        skillPorcentage: ["100%"],
                        SkillColor: ["progress-bar progress-bar-striped bg-info"]
                        }} />
                    </div>
                    {/* Hidden for now: JavaScript practice apps (Image Fetcher, Whattacook, Expenses List, Task List)
                    <div className="row apps-wrap">
                        <AppsComponent img={imageFetch} appName="Image Fetcher" hrefApp="https://imagefetch1212.netlify.app/"
                        hrefCode="https://github.com/thearturord/imagefetch1212"
                        appSkills = {{
                        skillName: ["JavaScript", "HTML"],
                        skillPorcentage: ["55%","45%"],
                        SkillColor: ["progress-bar progress-bar-striped", "progress-bar progress-bar-striped bg-success"]
                        }} />
                        <AppsComponent img={whattacook} appName="Whattacook" hrefApp="https://whattacook.netlify.app/"
                        hrefCode="https://github.com/thearturord/recipe-redi"
                        appSkills = {{
                        skillName: ["JavaScript", "HTML"],
                        skillPorcentage: ["98%","2%"],
                        SkillColor: ["progress-bar progress-bar-striped", "progress-bar progress-bar-striped bg-success"]
                        }}/>
                        <AppsComponent img={expensesList} appName="Expenses List" hrefApp={"https://app-expenses-6df40.web.app/"}
                        hrefCode={"https://github.com/thearturord/expensesList"}
                        appSkills = {{
                        skillName: ["JavaScript","HTML" , "CSS"],
                        skillPorcentage: ["96%","3%", "1%"],
                        SkillColor: ["progress-bar progress-bar-striped", "progress-bar progress-bar-striped bg-success", "progress-bar progress-bar-striped bg-danger"]
                        }} />
                        <AppsComponent img={taskList} appName="Task List" hrefApp="https://react-list-app1212.netlify.app/"
                        hrefCode="https://github.com/thearturord/React_task_list"
                        appSkills = {{
                        skillName: ["JavaScript", "HTML"],
                        skillPorcentage: ["60%","40%"],
                        SkillColor: ["progress-bar progress-bar-striped", "progress-bar progress-bar-striped bg-success"]
                        }} />
                    </div>
                    */}
                    <Outlet/>
                    {
                        location.pathname === "/apps" ?
                        <Link to='/' className="btn btn-light explore-btn-mobile">
                            See Less
                        </Link>
                        :
                        <Link to='/apps' className="btn btn-light explore-btn-mobile">
                            Load More
                        </Link>
                    }
                </div>


            </main>
            <div className="block footer">
                <div className="footer-contact" id="contact">
                    <h3>Get in touch</h3>
                    <p className="footer-contact-lead">
                        Open to SOC and Blue Team roles in Berlin — on-site or hybrid.
                    </p>
                    <div className="footer-contact-details">
                        <div className="footer-contact-item">
                            <span className="footer-contact-label">Email</span>
                            <EmailComponent className="footer-contact-value" user="tcatnoC" />
                        </div>                       
                        <div className="footer-contact-item">
                            <span className="footer-contact-label">Location</span>
                            <span className="footer-contact-value">Berlin, Germany</span>
                        </div>
                    </div>
                    <div className="footer-contact-links">
                        <a className="footer-contact-btn" rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/thearturord">
                            <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                        </a>
                        <a className="footer-contact-btn secondary" rel="noreferrer" target="_blank" href="https://github.com/thearturord?tab=repositories">
                            <FontAwesomeIcon icon={faSquareGithub} /> GitHub
                        </a>
                    </div>
                </div>
                <div className="footer-content">
                    <div className="impressum" id="impressum">
                        <h5>Impressum</h5>
                        <p>
                            Angaben gemäß § 5 TMG:<br/>
                            Arturo Nuñez Amado<br/>
                            Bernh-Lichtenberg-Str 17<br/>
                            10407 Berlin
                        </p>
                        <p>
                            <strong>Kontakt:</strong><br/>
                            E-Mail: <EmailComponent user="ved" noCopy />
                        </p>
                        <p>
                            <strong>Wirtschaftsidentifikationsnummer:</strong><br/>
                            Gemäß § 139c der Abgabenordnung: DE459846349
                        </p>

                        <p>
                            <strong>Umsatzsteuer-Hinweis:</strong><br/>
                            Als Kleinunternehmer im Sinne von § 19 Abs. 1 UStG wird keine Umsatzsteuer berechnet.
                        </p>
                    </div>
                </div>
                <div className="footer-bottom">
                    <h4>Portfolio Arturonunez.org</h4>
                </div>
            </div>
        </>
    );
}

export default Home;
